/**
 * Builds the URL slug for a member or alumni profile route.
 *
 * This is the single source for the profile route contract: `App.js` uses it to
 * declare `<Route path>` and `BrotherCardBase` uses it to build the card's
 * `href`, so the two can never disagree about where a person's page lives.
 *
 * The convention is unchanged — lowercase, all whitespace removed
 * ('Hong Dang' -> 'hongdang') — because those URLs are already published.
 *
 * Both call sites previously ran `name.toLowerCase().replace(" ", "")`
 * separately. Without the `g` flag that strips only the FIRST space, so any
 * three-word name kept a literal space in its path: 'Alexa Zamora Ambriz'
 * produced `/members/alexazamora ambriz`. In-app clicks still matched, because
 * both sides applied the identical broken transform, but the URL was not a
 * valid path to reload, bookmark, or share — the one thing the route exists for.
 */
export default function getProfileSlug(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '');
}
